import React from "react";

import CompleteAuditionSliderStar from "./CompleteAuditionSliderStar/CompleteAuditionSliderStar";
import SuperstarAuditionNav from "./SuperstarAuditionNav/SuperstarAuditionNav";

const SuperstarAudition = () => {
  return (
    <>
      <SuperstarAuditionNav />
      <div className="mt-3">
        <CompleteAuditionSliderStar />
      </div>
    </>
  );
};

export default SuperstarAudition;
